export { AvatarGroup } from './AvatarGroup';
export type {
  AvatarGroupContextValue,
  AvatarGroupContextValues,
  AvatarGroupProps,
  AvatarGroupSlots,
  AvatarGroupState,
  AvatarGroupBaseProps,
  AvatarGroupBaseState,
} from './AvatarGroup.types';
export { renderAvatarGroup_unstable } from './renderAvatarGroup';
export { defaultAvatarGroupSize, useAvatarGroup_unstable, useAvatarGroupBase_unstable } from './useAvatarGroup';
export { avatarGroupClassNames, useAvatarGroupStyles_unstable } from './useAvatarGroupStyles.styles';
export { useAvatarGroupContextValues } from './useAvatarGroupContextValues';
